import { render, staticRenderFns } from "./PlaytestModal.vue?vue&type=template&id=80ff1640"
import script from "./PlaytestModal.vue?vue&type=script&lang=js"
export * from "./PlaytestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports